export default {}

export const TOKEN_APP = 'lU1mMYl9t0msQ7lGKgXRpwpmp6bzaSV02WLA47uA43Lg'

export const BASE_URL = 'https://analitica.grdar.es/api/public'
export const API_URL = BASE_URL + '/'
export const API_UPLOADS = BASE_URL


// WEBPACK FOOTER //
// ./src/common/config.js